import { ClinicPatientFiltersType, ClinicPatientType, PaginationType, userType } from "../../DTO";
import { Api } from "../api";
import { convertToPaginationType } from "../help";
import { convertClinicPatientList } from "./shared";

export const FetchClinicPatientList = (
    user: userType,
    page: number,
    filters: ClinicPatientFiltersType,
) => {
    return new Promise<{ patients: ClinicPatientType[]; pagination: PaginationType }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: "clinic/patients",
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
                params: {
                    page,
                    "filter[first_name]": filters.firstName || undefined,
                    "filter[last_name]": filters.lastName || undefined,
                    "filter[email]": filters.email || undefined,
                    "filter[phone]": filters.phone || undefined,
                    "filter[condition]": filters.condition || undefined,
                    "filter[therapy]": filters.therapy || undefined,
                    "filter[signup_status]":
                        filters.signupStatus && filters.signupStatus !== "all"
                            ? filters.signupStatus
                            : undefined,
                },
            });

            return api
                .call()
                .then((data: any) => {
                    resolve({
                        patients: convertClinicPatientList(data.data ?? data),
                        pagination: data?.meta
                            ? convertToPaginationType(data.meta)
                            : {
                                  current_page: page,
                                  per_page: convertClinicPatientList(data.data ?? data)
                                      .length || 10,
                                  total: convertClinicPatientList(data.data ?? data)
                                      .length,
                              },
                    });
                })
                .catch((err: any) => reject(err));
        },
    );
};
